module.exports = __webpack_public_path__ + "static/crater-pitch-deck-6f988c80b1946a33eb64e95aa61c305d.pdf";